import React from 'react'

import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function Resend({ locale = 'en', onResend, onChangeEmail }) {
  const t = key => i18n.t(`auth_modal.code.${key}`, { ns: 'rails', lng: locale })

  return (
    <p className="auth-modal__resend cgt-body-base">
      {/* The prompt carries its own trailing space so locales without word
          spacing (ja, zh-CN) can omit it. */}
      {t('resend_prompt')}
      <button
        type="button"
        className="auth-modal__switch-link auth-modal__resend-link cgt-link-primary-accented"
        onClick={onResend}
      >
        {t('resend_link')}
      </button>
      <span className="auth-modal__resend-separator" aria-hidden="true">&middot;</span>
      <button
        type="button"
        className="auth-modal__switch-link auth-modal__change-email-link cgt-link-primary-accented"
        onClick={onChangeEmail}
      >
        {t('change_email_link')}
      </button>
    </p>
  )
}

Resend.propTypes = {
  locale: string,
  onResend: func.isRequired,
  onChangeEmail: func.isRequired,
}

export default Resend
